import { CuraleafSpinner } from '../../Loader/CuraleafSpinner';

export const Loader = (): JSX.Element | null => {
  return (
    <div className="account-loader">
      <CuraleafSpinner />
    </div>
  );
};
